import { render, staticRenderFns } from "./ReturnDialog.vue?vue&type=template&id=20b6309d&"
import script from "./ReturnDialog.vue?vue&type=script&lang=js&"
export * from "./ReturnDialog.vue?vue&type=script&lang=js&"
import style0 from "./ReturnDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2983364112/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20b6309d')) {
      api.createRecord('20b6309d', component.options)
    } else {
      api.reload('20b6309d', component.options)
    }
    module.hot.accept("./ReturnDialog.vue?vue&type=template&id=20b6309d&", function () {
      api.rerender('20b6309d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/OrderWidget/Return/ReturnDialog.vue"
export default component.exports